import "./UserAvatarComponent.scss";
import {CommonService} from "@/services";
import {Misc} from "@/constants";


const UserAvatarComponent = () => {

    const currentUser = CommonService._localStorage.getItem(Misc.LOCAL_STORAGE_LOGGED_IN_USER_DATA);
    const formattedUser = currentUser ? JSON.parse(currentUser) : null;
    const userName = formattedUser?.name || "User";

    const getInitials = (name: string) => {
        const words = name.trim().split(" ");
        return words.length > 1
            ? (words[0].charAt(0) + words[1].charAt(0)).toUpperCase()
            : words[0].charAt(0).toUpperCase();
    };

    return (
        <div className="user-avatar-component">
            {userName.length > 0 && (
                <div className="user-avatar-initials">{getInitials(userName)}</div>
            )}
        </div>
    );
};

export default UserAvatarComponent;
